import styled from '@emotion/styled';
import React, { forwardRef } from 'react';
import { typography } from '../../styles/typography';

interface IProps {
  title?: string;
  ref?: any;
  notLink?: boolean;
  [key: string]: any;
}

const Button = styled.div<Partial<IProps>>`
  flex: 1;

  display: flex;
  border: none;
  background: none;
  width: 100%;

  cursor: pointer;

  ${typography.h5}
  font-family: ${(props) => props.theme.font.family};
  color: ${(props) => props.theme.colors.primary};

  padding-top: 12px;
  padding-bottom: 12px;

  align-items: center;

  > svg {
    flex-shrink: 0;
  }
`;

const ButtonLink = styled(Button)`
  &:hover {
    text-decoration: underline;
  }
`;

export const CardButton = forwardRef(function CardButton(props: IProps, ref) {
  const { title, notLink, ...rest } = props;

  const content = (
    <>
      <svg
        width="16"
        height="12"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginTop: -4, marginRight: 10 }}
      >
        <g fill="none" fillRule="evenodd">
          <g stroke="currentColor">
            <path d="M9.395 1.665l5.32 4.655-5.32 4.655" />
            <path strokeLinejoin="round" d="M14.05 6.32H.75" />
          </g>
        </g>
      </svg>
      <span>{title}</span>
    </>
  );

  if (notLink) {
    return (
      <Button ref={ref} {...rest}>
        {content}
      </Button>
    );
  }

  return (
    <ButtonLink as="a" ref={ref} title={title} {...rest}>
      {content}
    </ButtonLink>
  );
});
